import { isAxiosError } from 'axios';

import { toast } from '@/components/ui/use-toast';
import { api } from '@/lib/api-client';
import { Matchdata } from '@/types/match';

export async function fetchMatchData(
  matchId: string | undefined,
  hideMap?: boolean,
): Promise<Matchdata> {
  try {
    if (!matchId) {
      throw new Error('Must pass a matchId');
    }
    const params = hideMap ? { hideMap: hideMap.toString() } : {};
    return api.get(`/matches/${matchId}`, {
      params,
    });
  } catch (error: any) {
    if (error.response && error.response.status === 404) {
      throw new Error('Match not found');
    } else {
      if (isAxiosError(error)) {
        toast({
          variant: 'destructive',
          title: 'Error',
          description: error.response?.data,
        });
      }
      throw error;
    }
  }
}
